import ReactOnRails from "react-on-rails";
import { BrowserExtensionTriggerEasyConnectTestField } from "../../components/templates/triggers/browserExtensionTriggers/BrowserExtensionTriggerEasyConnectTestField";
import { BrowserExtensionTriggerEasyConnectField } from "../../components/templates/triggers/browserExtensionTriggers/BrowserExtensionTriggerEasyConnectField";

ReactOnRails.register({
  BrowserExtensionTriggerEasyConnectTestField: BrowserExtensionTriggerEasyConnectTestField,
  BrowserExtensionTriggerEasyConnectField: BrowserExtensionTriggerEasyConnectField,
});
